export default __webpack_public_path__ + "static/media/hotel.32f737f0.jpeg";